import { LangDefinition } from '@jsverse/transloco';

export class Languages {
  static readonly availableLanguages: LangDefinition[] = [
    {
      id: 'en',
      label: 'English',
    },
    {
      id: 'sv',
      label: 'Svenska',
    },
    {
      id: 'sr-Latn',
      label: 'Srpski',
    },
    /*{
      id: 'is',
      label: 'Íslenska',
    },*/
  ];
}
